/**
 * Query keys of the Rewards Hub cache. A module of its own, with no imports,
 * so code outside the hub (the socket providers, the trade app's order hooks)
 * can refresh the hub without pulling its hooks in.
 */
/**
 * Everything the hub caches — the catalogue titles come translated into the
 * player's stored locale, so a language switch has to read all of it again.
 */
export const REWARDS_HUB_ROOT_QK = ['rewards-hub'] as const;

export const REWARDS_HUB_QK = {
  profile: ['rewards-hub', 'profile'] as const,
  daily: ['rewards-hub', 'daily'] as const,
  artifacts: ['rewards-hub', 'artifacts'] as const,
  ladders: ['rewards-hub', 'ladders'] as const,
  stats: ['rewards-hub', 'stats'] as const,
  counters: ['rewards-hub', 'counters'] as const,
  collection: ['rewards-hub', 'collection'] as const,
  scale: ['rewards-hub', 'scale'] as const,
  badges: ['rewards-hub', 'badges'] as const,
  steps: ['rewards-hub', 'steps'] as const,
  weekly: ['rewards-hub', 'weekly'] as const,
  season: ['rewards-hub', 'season'] as const,
  player: (userId: string, locale: string) => ['rewards-hub', 'player', userId, locale] as const,
};

/**
 * The active season, titles in the page's language — the server render and the
 * hook share it. A guest's answer has no progress, so it never stands in for a
 * player's: a server render that saw no session (localhost, a lapsed token)
 * reads the guest one, and the player's page reads its own.
 */
export function rewardsSeasonKey(locale: string, viewer: 'player' | 'guest') {
  return [...REWARDS_HUB_QK.season, locale, viewer] as const;
}

/** A Resolution Keeper's markets. */
export function rewardsSeasonEventsKey(taskId: string) {
  return [...REWARDS_HUB_QK.season, 'events', taskId] as const;
}

/** The ranks, named in the page's language — the server render and the hook share it. */
export function rewardsScaleKey(locale: string) {
  return [...REWARDS_HUB_QK.scale, locale] as const;
}
